import appTabs from './index.vue'

appTabs.install = function (Vue) {
  Vue.component(appTabs.name, appTabs)
}

export default appTabs
